<div class="relative notification-bell">
    <button
        type="button"
        (click)="toggle()"
        [attr.aria-label]="soChuaDoc > 0 ? 'Thông báo, ' + soChuaDoc + ' chưa đọc' : 'Thông báo'"
        class="relative w-10 h-10 flex justify-center items-center rounded-full text-gray-600 transition-all duration-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
        [class.bg-gray-100]="isOpen">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.268 21a2 2 0 0 0 3.464 0"/>
            <path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"/>
        </svg>
        <span *ngIf="soChuaDoc > 0"
            class="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-semibold leading-[18px] text-center ring-2 ring-white">
            {{ nhanBadge }}
        </span>
    </button>

    <div *ngIf="isOpen"
        class="bell-dropdown absolute right-0 mt-2 bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden z-50 animate-fadeIn flex flex-col"
        (click)="$event.stopPropagation()">
        <div class="flex items-center justify-between px-4 py-3 border-b border-gray-200">
            <p class="text-sm font-semibold text-gray-900">Thông báo</p>
            <button
                type="button"
                (click)="danhDauTatCa()"
                [disabled]="soChuaDoc === 0 || dangDanhDauTatCa"
                class="text-xs font-medium text-brand-primary hover:underline disabled:text-gray-400 disabled:no-underline disabled:cursor-default">
                Đánh dấu tất cả đã đọc
            </button>
        </div>

        <button *ngIf="hienNutBatThongBao"
            type="button"
            (click)="batThongBaoTrinhDuyet()"
            [disabled]="dangBatThongBao"
            class="w-full text-left px-4 py-2 text-xs font-medium text-brand-primary bg-blue-50 border-b border-gray-200 hover:underline disabled:text-gray-400 disabled:no-underline">
            Bật thông báo trên trình duyệt
        </button>

        <button *ngIf="hienNutGuiThu"
            type="button"
            (click)="guiThongBaoThu()"
            [disabled]="demNguocGuiThu !== null"
            class="w-full text-left px-4 py-2 text-xs font-medium text-purple-700 bg-purple-50 border-b border-gray-200 hover:underline disabled:no-underline disabled:cursor-default">
            <ng-container *ngIf="demNguocGuiThu === null">[DEV] Gửi thông báo thử (sau 5 giây)</ng-container>
            <ng-container *ngIf="demNguocGuiThu !== null">Gửi sau {{ demNguocGuiThu }} giây — chuyển sang tab/cửa sổ khác để thấy popup</ng-container>
        </button>
        <button *ngIf="hienNutGuiThu"
            type="button"
            (click)="thuPopupHeThong()"
            class="w-full text-left px-4 py-2 text-xs font-medium text-purple-700 bg-purple-50 border-b border-gray-200 hover:underline">
            [DEV] Thử popup Windows (không qua FCM)
        </button>

        <p *ngIf="thongBaoBiChan" class="px-4 py-2 text-xs text-amber-800 bg-amber-50 border-b border-gray-200">
            Thông báo trình duyệt đang bị chặn. Bấm biểu tượng bên trái thanh địa chỉ → Notifications → Allow, rồi tải lại trang.
        </p>

        <div class="bell-list overflow-y-auto" (scroll)="onScroll($event)">
            <button
                *ngFor="let item of items; trackBy: trackById"
                type="button"
                (click)="moThongBao(item)"
                class="w-full text-left flex gap-3 px-4 py-3 border-b border-gray-100 transition-colors duration-200 hover:bg-gray-50"
                [class.bell-unread]="!laDaDoc(item)">
                <span class="mt-1.5 w-2 h-2 rounded-full shrink-0"
                    [ngClass]="laDaDoc(item) ? 'bg-transparent' : 'bg-blue-500'"></span>
                <span class="min-w-0 flex-1">
                    <span class="block text-sm text-gray-900 break-words"
                        [class.font-semibold]="!laDaDoc(item)">{{ item.title || 'Thông báo' }}</span>
                    <span *ngIf="item.message" class="bell-message block text-xs text-gray-600 mt-0.5 break-words">{{ item.message }}</span>
                    <span class="block text-[11px] text-gray-400 mt-1" [attr.title]="item.createAt">{{ thoiGianTuongDoi(item) }}</span>
                </span>
            </button>

            <div *ngIf="dangTai" class="flex justify-center py-4">
                <span class="w-5 h-5 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin"></span>
            </div>

            <div *ngIf="coLoi && !dangTai" class="px-4 py-6 text-center text-sm text-gray-500">
                Không tải được thông báo.
                <button type="button" (click)="thuLai()" class="ml-1 font-medium text-brand-primary hover:underline">Thử lại</button>
            </div>

            <div *ngIf="!dangTai && !coLoi && items.length === 0" class="px-4 py-10 text-center text-sm text-gray-500">
                Chưa có thông báo
            </div>
        </div>
    </div>
</div>

<ng-template #loiMoiBatThongBao>
    <div class="flex gap-3">
        <span class="mt-0.5 text-brand-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10.268 21a2 2 0 0 0 3.464 0"/>
                <path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"/>
            </svg>
        </span>
        <div class="flex-1">
            <p class="text-sm font-semibold text-gray-900">Nhận thông báo trên trình duyệt?</p>
            <p class="text-xs text-gray-600 mt-1">Hồ sơ thay đổi trạng thái sẽ báo ngay cả khi bạn đang ở tab khác.</p>
            <div class="flex justify-end gap-2 mt-3">
                <button type="button" (click)="deSau()"
                    class="px-3 py-1 text-xs font-medium text-gray-600 rounded hover:bg-gray-100">Để sau</button>
                <button type="button" (click)="batThongBaoTrinhDuyet()" [disabled]="dangBatThongBao"
                    class="px-3 py-1 text-xs font-semibold text-white rounded bg-brand-primary hover:brightness-95 disabled:opacity-60">Bật</button>
            </div>
        </div>
    </div>
</ng-template>
